import { Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

export const TableHeader = () => {
  return (
    <thead style={{ borderBottom: '24px solid transparent' }}>
      <tr>
        <th style={{ width: 76 }} />
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Professional
          </Text>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Office
          </Text>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Shift Details
          </Text>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Review
          </Text>
        </th>
        <th />
      </tr>
    </thead>
  );
};
